import { useContext } from "react";
import { ApiContext } from "../../contexts/ApiContext";
import { useMutation } from "react-query";
import { RegionSubmission } from "../../shared/interfaces/Region";
import { QueryCallbacks } from "../../shared/interfaces/ReactQuery";

export function useCompanyCreation(callbacks?: QueryCallbacks<number>) {
  const apiContext = useContext(ApiContext);
  return useMutation({
    ...callbacks,
    mutationKey: ["submitCompany"],
    mutationFn: async (companySubmission: RegionSubmission) => apiContext.companyApis.createCompany(companySubmission),
  });
}
